"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAncestorSkipped = exports.getPercentCompletion = void 0;
const getEnabledQuestions_1 = __importDefault(require("./getEnabledQuestions"));
const isAnswerableQuestion_1 = __importDefault(require("./isAnswerableQuestion"));
const isValidAnswer_1 = __importDefault(require("./isValidAnswer"));
const getPercentCompletion = (form, questionNode) => {
    if (!questionNode)
        questionNode = form.questionTree;
    const enabled = (0, getEnabledQuestions_1.default)(questionNode, z => { var _a; return !((_a = form.answers[z.nodeId]) === null || _a === void 0 ? void 0 : _a.notApplicable); }).filter(isAnswerableQuestion_1.default);
    const stat = enabled.reduce((acc, node) => {
        const u = Object.assign({}, acc);
        const q = form.questions[node.nodeId];
        const r = form.rules[node.questionId];
        if ((0, isAnswerableQuestion_1.default)(q)) {
            u.req += 1;
        }
        const a = form.answers[node.nodeId];
        if ((0, isValidAnswer_1.default)(a, node, r) || isAncestorSkipped(form, node)) {
            u.ans += 1;
        }
        return u;
    }, { req: 0, ans: 0 });
    return stat.req > 0 ? Math.round((stat.ans * 100) / stat.req) : 0;
};
exports.getPercentCompletion = getPercentCompletion;
function isAncestorSkipped(form, questionNode) {
    var _a;
    if ((_a = form.answers[questionNode === null || questionNode === void 0 ? void 0 : questionNode.parentNodeId]) === null || _a === void 0 ? void 0 : _a.notApplicable) {
        return true;
    }
    else if ((questionNode === null || questionNode === void 0 ? void 0 : questionNode.parentNodeId) === 'root') {
        return false;
    }
    return isAncestorSkipped(form, form.questions[questionNode === null || questionNode === void 0 ? void 0 : questionNode.parentNodeId]);
}
exports.isAncestorSkipped = isAncestorSkipped;
exports.default = exports.getPercentCompletion;
